module.exports = __webpack_public_path__ + "img/logo.04aae137.png";